import React from "react";
import { Link } from "react-router-dom";

const SearchBtnGroup = () => {
  return (
    <div className="SearchBtnGroup">
      <button>
        <Link to="/resouces/Trading using Algos">Trading using Algos</Link>
      </button>
      <button>
        <Link type="button" to="/resouces/Java">
          Java
        </Link>
      </button>
      <button>
        <Link type="button" to="/resouces/Set up my account">
          Set up my account
        </Link>
      </button>
      <button>
        <Link type="button" to="/resouces/Set up my payment">
          Set up my payment
        </Link>
      </button>
      <button>
        <Link type="button" to="/resouces/Open startegy">
          Open startegy
        </Link>
      </button>
    </div>
  );
};

export default SearchBtnGroup;
